import { select, selectAll, on, addClass, removeClass, getHeight, hasClass } from 'modules/dom'
import { updateLazyLoad } from '../image/image'
import CardPost from '../card-post/card-post'
import nanoajax from 'nanoajax'

export default function (el) {
  const BLOG_WRAPPER = '.js-post-saved-ajax-block'
  const CARD_WRAPPER = '.card-post--four-up'
  const PAGINATION_BUTTONS = 'a.page-numbers'
  const LOADING = '.js-post-saved-ajax-loading'
  const INPUT_CHECK_WEBINAR = '.js-check-only-webinar'
  const ACTIVE = 'active'
  const STAR_BUTTON = '.js-button-star-favorite'

  const initDOMAjax = () => {
    const blockWrapper = select(BLOG_WRAPPER, el)
    const loadingWrapper = select(LOADING, el)
    const paginationButtons = selectAll(PAGINATION_BUTTONS, el)
    const inputCheckWebinar = select(INPUT_CHECK_WEBINAR, el)

    let onlyWebinar = 0
    if (inputCheckWebinar) onlyWebinar = inputCheckWebinar.value
    if (paginationButtons.length) {
      paginationButtons.map((pagination) => {
        on('click', function (e) {
          e.preventDefault()
          blockWrapper.innerHTML = ''
          addClass(ACTIVE, loadingWrapper)
          const hrefThis = e.currentTarget.href
          let paged = hrefThis.match(/\/\d+\//)[0]
          paged = paged.match(/\d+/)[0]
          if (!paged) paged = 1
          let url = `${window.location.origin}/wp-json/ecl/v1/get-saved-post?paged=${paged}&onlyWebinar=${onlyWebinar}`
          nanoajax.ajax(
            {
              method: 'GET',
              url
            },
            (code, response) => {
              const res = JSON.parse(response)
              if (code === 200) {
                removeClass(ACTIVE, loadingWrapper)
                blockWrapper.innerHTML = res.data
                const listCarts = selectAll(CARD_WRAPPER)
                const starButton = selectAll(STAR_BUTTON, el)

                if (listCarts.length) {
                  updateLazyLoad().handlers(true)
                  listCarts.map((cart) => {
                    //Re-active Star Button
                    addClass(ACTIVE, starButton);
                    const imageEl = select('.js-velo-image', cart)
                    const sponsorTextEl = select('.js-velo-sponsor', cart)
                    let contentAnimationPos
                    const imageHeight = getHeight(imageEl)
                    const offset = sponsorTextEl ? getHeight(sponsorTextEl) : 0
                    contentAnimationPos = Math.abs(imageHeight - offset) * -1
                    const isPaidContent = hasClass('js-card-paid', cart)
                    if (isPaidContent) {
                      contentAnimationPos -= 3
                    }
                    CardPost(cart, contentAnimationPos)
                  })
                }
                initDOMAjax()
              }
            }
          )
        }, pagination)
      })
    }
  }
  initDOMAjax()
}


